import React, { Component } from "react";

import { Row, Col, Button, Popover, Card, Modal } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import {
  InstagramOutlined,
  MailOutlined,
  LinkedinOutlined,
} from "@ant-design/icons";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/HumanResource/HumanResource.css";

import HumanResourceCard from "./HumanResourceCard.js";

import tmp from "../../../Imgs/AboutUs/HumanResource/Managers/temp.png";
import manager3 from "../../../Imgs/AboutUs/HumanResource/Managers/3.jpg";
import manager4 from "../../../Imgs/AboutUs/HumanResource/Managers/4.jpg";
import manager5 from "../../../Imgs/AboutUs/HumanResource/Managers/5.JPG";
import manager6 from "../../../Imgs/AboutUs/HumanResource/Managers/6.jpg";
import manager7 from "../../../Imgs/AboutUs/HumanResource/Managers/7.jpg";
import manager8 from "../../../Imgs/AboutUs/HumanResource/Managers/8.jpg";
import manager9 from "../../../Imgs/AboutUs/HumanResource/Managers/9.jpg";
import manager10 from "../../../Imgs/AboutUs/HumanResource/Managers/10.JPG";
import manager11 from "../../../Imgs/AboutUs/HumanResource/Managers/11.JPG";
import manager12 from "../../../Imgs/AboutUs/HumanResource/Managers/12.JPG";
import manager13 from "../../../Imgs/AboutUs/HumanResource/Managers/13.JPG";
import manager14 from "../../../Imgs/AboutUs/HumanResource/Directors/1.jpg";
import manager15 from "../../../Imgs/AboutUs/HumanResource/Managers/14.JPG";
import manager16 from "../../../Imgs/AboutUs/HumanResource/Deputy/2.jpg";
import manager17 from "../../../Imgs/AboutUs/HumanResource/Managers/15.jpg";
import manager18 from "../../../Imgs/AboutUs/HumanResource/Directors/8.jpg";

const DirectorsTab = (props) => {
  return props.size === "laptopdesktop" ? (
    <div>
      <Margin top={4}></Margin>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>
            <Col span={5}>
              <HumanResourceCard
                img={manager15}
                name="علی کرمی"
                job="مدیریت زنجیره تامین"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={5}>
              <HumanResourceCard
                img={manager9}
                name="علی اکبر مرادنژاد"
                job="مدیریت مالی و سرمایه گذاری"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={5}>
              <HumanResourceCard
                img={manager17}
                name="سید جواد میرقاسمی"
                job="مدیریت حقوقی"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={5}>
              <HumanResourceCard
                img={manager16}
                name="حسین امینی صدر"
                job="مدیریت بازرسی و نظارت"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>
            <Col span={5}>
              <HumanResourceCard
                img={manager6}
                name="سمیه شهیدی فر"
                job="مدیریت بیمه های اموال"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={5}>
              <HumanResourceCard
                img={manager13}
                name="نیما لطفی"
                job="مدیریت بیمه‌های خودرو"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={5}>
              <HumanResourceCard
                img={manager3}
                name="امین عبدالهی"
                job="مديریت فناوری اطلاعات"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>

            <Col span={5}>
              <HumanResourceCard
                img={manager10}
                name="شهرام ‌حیدر زاده"
                job="مدیر دفتر مدیرعامل و اعضای هیات مدیره"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>
            <Col span={5}>
              <HumanResourceCard
                img={manager7}
                name="هومن اطمینان"
                job="مدیریت منابع انسانی و پشتیبانی"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={5}>
              <HumanResourceCard
                img={manager12}
                name="رضا منصورنیا"
                job="مدیریت روابط عمومی و رسانه "
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>

            <Col span={5}>
              <HumanResourceCard
                img={manager5}
                name="کامران عطشانی"
                job="مدیریت هماهنگی گروه شرکت‌ها"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>

            <Col span={5}>
              <HumanResourceCard
                img={manager11}
                name="مریم السادت موسوی"
                job="مدیریت بیمه‌های کشاورزی "
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>

            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div>
      <Margin top={4}></Margin>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>
            <Col span={10}>
              <HumanResourceCard
                img={manager17}
                name="سید جواد میرقاسمی"
                job="مدیریت حقوقی"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={10}>
              <HumanResourceCard
                img={manager16}
                name="حسین امینی صدر"
                job="مدیریت بازرسی و نظارت"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>
            <Col span={10}>
              <HumanResourceCard
                img={manager15}
                name="علی کرمی"
                job="مدیریت زنجیره تامین"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={10}>
              <HumanResourceCard
                img={manager9}
                name="علی اکبر مرادنژاد"
                job="مدیریت مالی و سرمایه گذاری"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>

            <Col span={10}>
              <HumanResourceCard
                img={manager3}
                name="امین عبدالهی"
                job="مديریت فناوری اطلاعات"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={10}>
              <HumanResourceCard
                img={manager10}
                name="شهرام ‌حیدر زاده"
                job="مدیر دفتر مدیرعامل و اعضای هیات مدیره"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>
            <Col span={10}>
              <HumanResourceCard
                img={manager6}
                name="سمیه شهیدی فر"
                job="مدیریت بیمه های اموال"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={10}>
              <HumanResourceCard
                img={manager13}
                name="نیما لطفی"
                job="مدیریت بیمه‌های خودرو"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>

            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>

            <Col span={10}>
              <HumanResourceCard
                img={manager11}
                name="مریم السادت موسوی"
                job="مدیریت بیمه‌های کشاورزی "
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={10}>
              <HumanResourceCard
                img={manager7}
                name="هومن اطمینان"
                job="مدیریت منابع انسانی و پشتیبانی"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>

            <Col span={10}>
              <HumanResourceCard
                img={manager12}
                name="رضا منصورنیا"
                job="مدیریت روابط عمومی و رسانه "
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={10}>
              <HumanResourceCard
                img={manager5}
                name="کامران عطشانی"
                job="مدیریت هماهنگی گروه شرکت‌ها"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
    </div>
  ) : (
    <div>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={manager16}
            name="حسین امینی صدر"
            job="مدیریت بازرسی و نظارت"
            phone=""
            mail=""
            size="laptopdesktop"
          />
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={manager17}
            name="سید جواد میرقاسمی"
            job="مدیریت حقوقی"
            phone=""
            mail=""
            size="laptopdesktop"
          />
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={manager9}
            name="علی اکبر مرادنژاد"
            job="مدیریت مالی و سرمایه گذاری"
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={manager15}
            name="علی کرمی"
            job="مدیریت زنجیره تامین"
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>

      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={manager10}
            name="شهرام ‌حیدر زاده"
            job="مدیر دفتر مدیرعامل و اعضای هیات مدیره"
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={manager3}
            name="امین عبدالهی"
            job="مديریت فناوری اطلاعات"
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={manager13}
            name="نیما لطفی"
            job="مدیریت بیمه‌های خودرو"
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>

      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={manager6}
            name="سمیه شهیدی فر"
            job="مدیریت بیمه های اموال"
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={manager11}
            name="مریم السادت موسوی"
            job="مدیریت بیمه‌های کشاورزی "
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>

      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={manager7}
            name="هومن اطمینان"
            job="مدیریت منابع انسانی و پشتیبانی"
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={manager12}
            name="رضا منصورنیا"
            job="مدیریت روابط عمومی و رسانه "
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>

      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={manager5}
            name="کامران عطشانی"
            job="مدیریت هماهنگی گروه شرکت‌ها"
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>
    </div>
  );
};

export default DirectorsTab;
